import { Box } from "@mui/material";
import React from "react";

const BadgeImage = ({ badge }: { badge: number }) => {
  return (
    <Box
      sx={{
        width: 18,
        height: 18,
      }}
    >
      {badge === 2 && (
        <img
          src="/assets/icons/home/badge-yellow.png"
          alt="Badge"
          width={"90%"}
          height={"90%"}
        />
      )}
      {badge === 1 && (
        <img
          src="/assets/icons/home/badge-green.png"
          alt="Badge"
          width={"100%"}
          height={"100%"}
        />
      )}
    </Box>
  );
};

export default BadgeImage;
